export const fonts = {
  rubik: "'Rubik', sans-serif",
};
